import React from "react";

export class Placeholder extends React.Component {
	render() {
		let children = Placeholder.sanitizeData(this.props.children || null);
		return this.props.watch ? children : <div className={`element--content-placeholder w${this.props.width || 12}`}><div><span>{this.props.content || <span>&nbsp;</span>}</span></div></div>;
	}

	static sanitizeData(data) {
		if(data === null) {
			return data;
		} else if(data instanceof Array) {
			data = <span>{data}</span>;
		} else if(typeof data !== 'object') {
			data = <span>{data}</span>;
		}
		return data;
	}
}
